import type { FC } from 'react';

import { typographyVariants } from '@mint-lib/tw-components';

type Props = {
  title: string;
  description?: string;
};

const CardHeader: FC<Props> = ({ title, description }) => {
  return (
    <div className="grid gap-1.5">
      <h6 className={typographyVariants({ variant: 'h6' })}>{title}</h6>
      {description ? (
        <p
          className={typographyVariants({
            variant: 'bodyLong01',
            color: 'secondary',
          })}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default CardHeader;
